<template>
	<div
		id="input-container"
		:class="{
			focused,
			filled,
		}"
	>
		<input
			:id="inputRandomRef"
			:ref="inputRandomRef"
			:key="inputRandomRef"
			v-model="newSearch"
			v-debounce:1000="delayedCallback"
			tabindex="0"
			type="text"
			class="form-control w-full"
			:class="[
				customClasses,
				{
					filled,
				},
			]"
			:placeholder="placeholder"
			@focus="HandleFocus"
			@blur="HandleBlur"
			@input="$emit('input', $event.target.value)"
			@keyup.esc.stop="ClearSearchText"
			@keyup.enter.stop="$emit('search', newSearch)"
		/>
		<span
			ref="clearIcon"
			class="clear-icon"
			@click="ClearSearchText"
		>
			<i class="fas fa-times"></i>
		</span>
	</div>
</template>

<script>
	export default {
		name: 'SearchInput',
		props: {
			search: {
				type: String,
				required: true,
			},
			placeholder: {
				type: String,
				default: 'BUSCAR...',
			},
			autofocus: {
				type: Boolean,
				default: true,
			},
			delayedCallback: {
				type: Function,
				default: () => {},
			},
			customClasses: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				inputRandomRef: `input_search_${parseInt(
					Math.random() * 1000
				)}`,
				newSearch: '',
				focused: false,
			}
		},
		computed: {
			filled() {
				return this.newSearch.length
			},
		},
		watch: {
			newSearch: {
				handler(newSearch) {
					this.Change(newSearch)
					this.HandleShowClearIcon(newSearch)
				},
			},
		},
		methods: {
			AutoFocusHandler() {
				if (this.autofocus) {
					this.$refs[this.inputRandomRef].focus()
					this.$refs[this.inputRandomRef].tabindex = 0
				}
			},
			ClearSearchText() {
				this.newSearch = ''

				setTimeout(() => {
					this.$emit('input', this.newSearch)
					this.$emit('search', this.newSearch)
					this.delayedCallback()
					this.AutoFocusHandler()
				}, 0)
			},
			HandleShowClearIcon(search) {
				const clearIcon = this.$refs.clearIcon

				if (search?.length) clearIcon.style.display = 'block'
				else clearIcon.style.display = 'none'
			},
			Change(newSearch) {
				this.$emit('change', newSearch)
			},
			HandleFocus() {
				this.focused = true
				this.$emit('focus')
			},
			HandleBlur() {
				this.focused = false
				this.$emit('blur')
			},
		},
		directives: {
			focus: {
				inserted(el) {
					el.focus()
				},
				update(el) {
					el.focus()
				},
			},
		},
		mounted() {
			this.AutoFocusHandler()
		},
	}
</script>

<style lang="scss" scoped>
	#input-container {
		position: relative;

		input {
			padding: 0.6rem 1.7rem 0.6rem 0.6rem;

			&.light {
				border: unset;
				padding: 0;
			}

			&.form-control {
				height: 100%;
			}
		}

		.clear-icon {
			display: none;
			position: absolute;
			transform: translateY(-50%);
			top: 50%;
			right: 0.1rem;
			font-size: 1.5rem;
			padding: 0 0.5rem;
			cursor: pointer;
			color: var(--newPrimaryBackgroundColor);

			&:hover {
				color: var(--newPrimaryFocusColor);
			}
		}

		&.focused {
			input.form-control {
				background-color: var(--newPrimaryFocusBackgroundColor);
				color: var(--newPrimaryFocusColor);
				outline: none;
				caret-color: var(--newPrimaryFocusColor);

				&::placeholder {
					color: var(--newPrimaryFocusColor);
				}
			}
		}
	}
</style>
